<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption"
                  ref="mySwiper_info">
            <swiper-slide v-for="(item, index) in topRotation"
                          :key="index">
              <!-- <img :src="item.resUrl" class="imgBanner" @click="Towindowurl(item.url)" style="cursor:pointer" width="930" height="380"> -->
              <img :src="item.resUrl"
                   class="imgBanner"
                   style="border-radius: 20px 0px 0px 0px; cursor: pointer;"
                   width="930"
                   height="380"
                   @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright">
          <swiper :options="swiperOption2"
                  ref="mySwiper">
            <swiper-slide v-for="(item, index) in topRotation"
                          :key="index"
                          @click="Towindowurl(item.url)"
                          :style="{ backgroundImage: 'url(' + item.resRightUrl + ')', backgroundSize: '100% 100%' }">
              <div>
                <img src="/image/index/index2tuceng.png"
                     class="shan" />
                <div style="padding:40px 50px">
                  <div class="bannerTitle">{{ item.title }}</div>
                  <div class="bannerline"></div>
                  <div class="bannerText">
                    <span v-html="ellipsis(item.detail, 120)"></span>
                  </div>
                  <div class="marginTop20">
                    <a href="javascript:void(0);"
                       @click="Towindowurl(item.url)"
                       class="bannerBtn">了解更多</a>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="main display_between_nocenter EC_width"
         style="padding-bottom:30px">
      <div class="mainLeft">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ dxal55 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(classicCases[0].cid, dxal55)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="tip_panel marginTop20 display_column">
          <div class="flex1"></div>
          <div class="tips">
            <span v-for="(item, index) in classicCases.slice(0, 2)"
                  :key="index"
                  @click="clkNews(item, dxal55)">
              <!-- <p >[典型经验]</p> -->
              <p v-if="index == 0"
                 style="cursor: pointer;">
                {{ ellipsis(item.title, 15) }}
              </p>
              <p v-if="index == 1"
                 class="marginTop10 marginBottom10"
                 style="border-bottom: 1px solid #fff"></p>
              <p v-if="index == 1"
                 style="cursor: pointer;">
                {{ ellipsis(item.title, 15) }}
              </p>
              <!-- <p>量完善机制务实重干</p> -->
            </span>
          </div>
        </div>
        <div class="border_top_18 marginTop23"
             v-for="(item, index) in classicCases.slice(2, 6)"
             :key="index"
             @click="clkNews(item, dxal55)">
          <div class="gl_title_vertical_line gl_title_v_line_active_gree">
            <span style="cursor: pointer;">{{ ellipsis(item.title, 20) }}</span>
          </div>
        </div>
      </div>
      <div class="mainCenter flex1">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="tagTitle tagTitleActive">{{ jcdt49 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(developmentList[0].cid, jcdt49)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div v-for="(item, index) in developmentList"
             :key="index + '1'">
          <div class="gl_listWrapBar_nopad controlShow"
               style="margin: 20px 0;">
            <div class="gl_imgList setShow"
                 @click="clkNews(item, jcdt49)">
              <img :src="item.slideShow"
                   width="150"
                   height="88"
                   class="imgtran" />
            </div>
            <a href="javascript:;"
               class="gl_listItem display_column">
              <div class="gl_listItemTitle fontBold setShow"
                   @click="clkNews(item, jcdt49)">
                {{ item.title }}
              </div>
              <div class="gl_listItemTitle disShow"
                   style="line-height:9.5px;"
                   @click="clkNews(item, jcdt49)">
                {{ item.title }}
              </div>
              <div class="display_between marginTop10 setShow">
                <div>
                  <span v-bind:class="calculate(index)"
                        v-for="(qitem, index) in (item.labelName || '').split(',')"
                        :key="index"
                        @click="onsearch(qitem)">
                    {{ qitem }}
                  </span>
                </div>
                <div class="gl_inforshow ">
                  <span class="marginRight20">
                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                  </span>
                  <span>
                    <img src="/image/index/chakan.png" />
                    {{ item.clickVolume }}
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ jcrgc50 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(observationList[0].cid, jcrgc50)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <!-- video_block marginTop10 -->
        <div class="marginTop17"
             v-for="(item, index) in observationList"
             :key="index + '1'"
             @click="clkNews(item, jcrgc50)">
          <!-- <video controls="controls">
                        当前浏览器不支持 video直接播放，点击这里下载视频： <a href="myvideo.webm">下载视频</a>
                    </video> -->
          <div>
            <img class="imgBanner"
                 :src="item.slideShow"
                 alt=""
                 width="300px"
                 height="169" />
          </div>
          <div class="video_title">
            {{ ellipsis(item.title, 16) }}
          </div>
        </div>
      </div>
    </div>
    <KeCheng labelName="社区卫生管理"
             newlabelName="社区卫生服务管理"></KeCheng>
    <div class="text_center"
         v-for="(item, index) in centerRotation"
         :key="3 - index"
         @click="Towindowurl(item.url)">
      <img :src="item.resUrl"
           class="imgtran"
           width="1200"
           height="110" />
    </div>
    <div class="main display_between_nocenter EC_width">
      <div class="mainLeft">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ guyuan56 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(gyStudio[0].cid, guyuan56)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="gl_listWrapBar_noflex"
             v-for="(item, index) in gyStudio"
             :key="index + '1'"
             @click="clkNews(item, guyuan56)">
          <div class="gl_imgList marginBottom10">
            <img :src="item.slideShow"
                 v-if="item.slideShow != ''"
                 width="200"
                 height="128"
                 class="imgtran" />
          </div>
          <a class="gl_listItem">
            <div class="gl_listItemTitle">
              <span style=" cursor: pointer;">
                {{ ellipsis(item.title, 22) }}
              </span>
            </div>
            <div class="display_between marginTop10">
              <div class="gl_inforshow">
                <span class="marginRight20">
                  {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                </span>
              </div>
              <div class="gl_inforshow">
                <span>
                  <img src="/image/index/chakan.png"
                       class="marginRight5" />
                  {{ item.clickVolume }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="mainCenter flex1">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="tagTitle"
                  :class="{ tagTitleActive: baseTagindex == index }"
                  @click="tagDatabase(index, item)"
                  v-for="(item, index) in intocommuni"
                  :key="index">
              {{ item.name }}
            </span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(intocommuni[baseTagindex].id, intocommuni[baseTagindex].name)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div v-for="(item, index) in newinfoList"
             :key="index + '1'">
          <div class="gl_listWrapBar"
               v-if="grastab == item.cid">
            <div class="gl_imgList"
                 @click="clkNews(item)">
              <img :src="item.slideShow"
                   v-if="item.slideShow != ''"
                   width="156"
                   height="88"
                   class="imgtran" />
            </div>
            <a href="javascript:;"
               class="gl_listItem display_column display_between_nocenter">
              <div class="gl_listItemTitle titleRow2"
                   @click="clkNews(item, intocommuni[baseTagindex].name)">
                <!-- {{ item.title }} -->
                {{ ellipsis(item.title, 50) }}
              </div>
              <div class="gl_listItemSub"
                   @click="clkNews(item, intocommuni[baseTagindex].name)"></div>
              <div class="display_between marginTop10">
                <div>
                  <span v-bind:class="calculate(index)"
                        v-for="(qitem, index) in (item.labelName || '').split(',')"
                        :key="index"
                        @click="onsearch(qitem)">
                    {{ qitem }}
                  </span>
                </div>
                <div class="gl_inforshow">
                  <span class="marginRight20">
                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                  </span>
                  <span>
                    <img src="/image/index/chakan.png"
                         class="marginRight5" />
                    {{ item.clickVolume }}
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="mainRight">
        <div class="gl_title_bar">
          <div class="gl_tb_left">
            <span class="normaltitle">{{ jyzs57 }}</span>
          </div>
          <div class="gl_tb_right"
               @click="onMore(FamilyClinic[0].cid, jyzs57)">
            <a href="javascript:;"
               class="gl_tb_right_more">
              <img src="/image/index/moreimg.png"
                   class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="border_bottom_18"
             v-for="(item, index) in FamilyClinic"
             :key="index + '1'"
             @click="clkNews(item, jyzs57)">
          <div class="gl_title_vertical_line marginBottom20 marginTop35">
            <span style=" cursor: pointer;">
              {{ ellipsis(item.title, 15) }}
            </span>
          </div>
          <a>
            <img :src="item.slideShow"
                 class="imgtran"
                 width="300"
                 height="169" />
          </a>
        </div>
      </div>
    </div>
    <KeCheng labelName="典型案例"
             newlabelName="基层卫生典型案例"></KeCheng>
  </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
import KeCheng from '../../components/kecheng';
export default {
  name: 'health',
  components: {
    KeCheng
  },
  data () {
    return {
      apiData: {
        bannerImgList: {},
        baseNews: {},
        baseSee: {},
        studio: {},
        intoCommunity: {},
        homeClinic: {}
      },
      // 基层动态切换
      baseTagindex: 0,
      swiperOption: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },

        on: {
          slideChangeTransitionEnd: () => {
            this.$refs.mySwiper.swiper.slideTo(this.$refs.mySwiper_info.swiper.activeIndex, 200, false);
          }
        }
      },
      swiperOption2: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false
        },

        on: {
          slideChangeTransitionEnd: () => {
            this.$refs.mySwiper_info.swiper.slideTo(this.$refs.mySwiper.swiper.activeIndex, 200, false);
          }
        }
      },
      /**tianlianpei */
      // 走进社区导航
      grastab: 51,
      hotnavname: '走进社区',
      intocommuni: [], //走进社区，主任风采，加以团队，家医风采
      newinfoList: [], //走进社区，主任风采，加以团队，家医风采
      topRotation: [],
      centerRotation: [],
      botRotation: [],
      columntopList: [],
      developmentList: [], //基层动态
      observationList: [], //基层锐观察
      classicCases: [], //典型案例
      gyStudio: [], //顾湲工作室
      FamilyClinic: [], //家医诊所
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
      jcdt49: '',
      jcrgc50: '',
      dxal55: '',
      guyuan56: '',
      jyzs57: ''
    };
  },
  created () {
    // this.getData()
    this.GetRotationInfo();
    this.GetColumsInfoAllList();
  },
  methods: {
    onsearch (keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords
        }
      });
      window.open(href, '_blank');
    },
    calculate (index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    tagDatabase (index, item) {
      // 基层动态0 主任风采1 家医团队2 家医风采3数据
      this.grastab = item.id;
      this.baseTagindex = index;
    },

    /**tianlianpei */
    /**获取轮播数据 */
    GetRotationInfo () {
      let _this = this;
      let arr = [6, 7, 8, 24]; //分别代表基层卫生顶部轮播，中部banner，底部banner,右侧
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 6) {
                _this.topRotation = res.data.data || null;
              }
              if (arr[i] == 7) {
                _this.centerRotation = res.data.data || null;
              }
              if (arr[i] == 8) {
                _this.botRotation = res.data.data || null;
              }
            }
          });
      }
    },

    /**获取栏目数据 */
    GetColumsInfoAllList () {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data.sort(function (a, b) {
              return a.sort - b.sort;
            });
            data.forEach(item => {
              if (item.id >= 49 && item.id <= 57) {
                _this.columntopList.push(item);
              }
              if (item.id >= 51 && item.id <= 54) {
                _this.intocommuni.push(item);
              }
              switch (item.id) {
                case 49:
                  _this.jcdt49 = item.name;
                  break;
                case 50:
                  _this.jcrgc50 = item.name;
                  break;
                case 55:
                  _this.dxal55 = item.name;
                  break;
                case 56:
                  _this.guyuan56 = item.name;
                  break;
                case 57:
                  _this.jyzs57 = item.name;
                  break;
              }
            });

            //获取首页热门内容数据
            _this.GetGpSiteNewInfoPageList();
          }
        });
    },
    /**获取首页中部新闻信息 */
    GetGpSiteNewInfoPageList () {
      let _this = this;
      let arrcolumntop = _this.columntopList;
      let pagesize = 4;

      for (let i = 0; i < arrcolumntop.length; i++) {
        if (arrcolumntop[i].id == 57) {
          pagesize = 2;
        } else if (arrcolumntop[i].id == 50) {
          pagesize = 3;
        } else if (arrcolumntop[i].id == 49) {
          pagesize = 17;
        } else if (arrcolumntop[i].id == 55) {
          pagesize = 6;
        } else if (arrcolumntop[i].id == 56) {
          pagesize = 2;
        } else {
          pagesize = 4;
        }

        _this.httphelper
          .post('/api/NewApi/GetGpSiteNewInfoPageList', {
            keyword: '',
            id: 0,
            parentID: 0,
            column_Type: arrcolumntop[i].id,
            pageIndex: 0,
            pageSize: pagesize
          })
          .then(res => {
            if (res.data.code == 200) {
              let gpSiteNewInfoViewsViews = res.data.data.gpSiteNewInfoViewsViews;
              if (gpSiteNewInfoViewsViews != null && gpSiteNewInfoViewsViews.length > 0) {
                gpSiteNewInfoViewsViews.forEach(item => {
                  if (item.cid == 49) {
                    //基层动态
                    _this.developmentList.push(item);
                  }
                  if (item.cid == 50) {
                    _this.observationList.push(item);
                  }
                  if (item.cid >= 51 && item.cid <= 54) {
                    _this.newinfoList.push(item);
                  }
                  if (item.cid == 55) {
                    _this.classicCases.push(item);
                  }
                  if (item.cid == 56) {
                    _this.gyStudio.push(item);
                  }
                  if (item.cid == 57) {
                    _this.FamilyClinic.push(item);
                  }
                });
              }
            }
          });
      }
    },
    /**新闻的点击事件 */
    clkNews (info, meuntitle) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        var param = {
          pid: 35,
          title: meuntitle,
          cid: info.cid,
          goroutename: 'grassheal/Inforlist'
        };
        localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
        const { href } = this.$router.resolve({
          path: '/grassheal/Inforlist/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    /**轮播、广告图跳转外链 */
    Towindowurl (url) {
      if (url != null && url != '') window.open(url);
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /**更多 */
    onMore (cid, conetntitle) {
      this.$router.push({
        path: '/grassheal/Inforlist',
        query: {
          pid: 35,
          title: conetntitle,
          cid: cid
        }
      });
    }
  },
  mounted () { }
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
    min-width: 1240px;
}

/* 上部banner */

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    /* background: #005660; */
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 0px 0px 0px;
}

.bannerright {
    width: 299px;
    height: 380px;
    background: #dfa633;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 20px 0px;
    overflow: hidden;
    /* padding: 50px 40px; */
    box-sizing: border-box;
    position: relative;
}
.swiper-container,
.swiper-slide {
    width: 100%;
    height: 100%;
}
.shan {
    position: absolute;
    right: 0;
    bottom: 0;
}
.bannerTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 38px;
}
.bannerText {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
}
.bannerline {
    width: 40px;
    height: 1px;
    background: #ffffff;
    margin-top: 20px;
    margin-bottom: 18px;
}
.bannerBtn {
    display: inline-block;
    width: 121px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    line-height: 32px;
    text-align: center;
}
.main {
    padding: 50px 0;
}

.mainCenter {
    margin: 0 50px;
}

.mainLeft {
    width: 200px;
}

.mainRight {
    width: 300px;
}

.newsList a {
    font-size: 18px;
}

.newsList p {
    line-height: 38px;
}

.tip_panel {
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 28px;
    padding-bottom: 23px;
    height: 302px;
    background: url(/image/index/leftbgjiceng.png) no-repeat;
    background-size: 100% 100%;
}
.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}
.tips {
    color: #fff;
    font-size: 16px;
}
.setShow {
    display: none;
}
.controlShow:hover .setShow {
    display: flex;
}
.fontBoldnew {
    font-size: 16px;
}
.controlShow:hover .fontBoldnew {
    font-size: 16px;
    font-weight: bold;
}
.controlShow:hover .disShow {
    display: none;
}
.titleRow2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
